import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["title", "extra", "onLeftInput"],
  _excluded2 = ["title", "extra", "onRightInput"];
import { Fragment, createContext, useContext, useReducer, useRef, useCallback } from 'react';
import { Wrapper, StyledLayout, CopyButton, Button, CodeEditor, ErrorLayout } from "./index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ValueContext = /*#__PURE__*/createContext({});
var useValue = () => {
  return useContext(ValueContext);
};
var reducer = (state, action) => {
  return _extends({}, state, action);
};
export function LayoutEditorConverter(props) {
  var _useReducer = useReducer(reducer, _extends({
      val: '',
      json: ''
    }, props)),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  return /*#__PURE__*/_jsxs(ValueContext.Provider, {
    value: _extends({}, state, {
      state,
      dispatch
    }),
    children: [/*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsx(LeftLayout, {}), /*#__PURE__*/_jsx(RightLayout, {})]
    }), state.error && /*#__PURE__*/_jsx(ErrorLayout, {
      children: state.error
    })]
  });
}
function LeftLayout() {
  var _useValue = useValue(),
    jsonStr = _useValue.json,
    leftProps = _useValue.leftProps,
    _useValue$sample = _useValue.sample,
    sample = _useValue$sample === void 0 ? {} : _useValue$sample,
    state = _useValue.state,
    input = _useValue.input,
    dispatch = _useValue.dispatch;
  var _ref = leftProps || {},
    title = _ref.title,
    extra = _ref.extra,
    onLeftInput = _ref.onLeftInput,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  var editor = useRef(null);
  var leftInput = useCallback(val => onLeftInput ? onLeftInput(val, 'json') : '', [state]);
  var handleInput = val => {
    try {
      var jsonTrans = leftInput(val);
      dispatch({
        input: 'json',
        json: val,
        val: jsonTrans
      });
    } catch (err) {
      if (err instanceof Error) {
        dispatch({
          error: "" + err.message
        });
      }
    }
  };
  return /*#__PURE__*/_jsx(StyledLayout, {
    title: title || 'JSON',
    extra: /*#__PURE__*/_jsxs(Fragment, {
      children: [extra, jsonStr && /*#__PURE__*/_jsx(CopyButton, {
        value: jsonStr
      }), sample.json && /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          var _editor$current;
          (_editor$current = editor.current) == null || (_editor$current = _editor$current.view) == null || _editor$current.focus();
          handleInput(sample.json || '');
        },
        children: "Sample"
      })]
    }),
    children: /*#__PURE__*/_jsx(CodeEditor, _extends({
      value: jsonStr,
      ref: editor,
      readOnly: input !== 'json',
      height: "calc(100vh - 87px)"
    }, other, {
      onFocus: () => {
        dispatch && dispatch({
          input: 'json'
        });
      },
      onChange: val => {
        if (input === 'json') {
          handleInput(val);
        }
      }
    }))
  });
}
function RightLayout() {
  var _useValue2 = useValue(),
    valStr = _useValue2.val,
    rightProps = _useValue2.rightProps,
    _useValue2$sample = _useValue2.sample,
    sample = _useValue2$sample === void 0 ? {} : _useValue2$sample,
    input = _useValue2.input,
    dispatch = _useValue2.dispatch;
  var _ref2 = rightProps || {},
    title = _ref2.title,
    extra = _ref2.extra,
    onRightInput = _ref2.onRightInput,
    other = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  var editor = useRef(null);
  var handleInput = val => {
    try {
      var valTrans = onRightInput ? onRightInput(val, 'val') : '';
      dispatch({
        input: 'val',
        val: val,
        json: valTrans
      });
    } catch (err) {
      if (err instanceof Error) {
        dispatch({
          error: "" + err.message
        });
      }
    }
  };
  return /*#__PURE__*/_jsx(StyledLayout, {
    title: title || 'Value',
    extra: /*#__PURE__*/_jsxs(Fragment, {
      children: [extra, valStr && /*#__PURE__*/_jsx(CopyButton, {
        value: valStr
      }), sample.val && /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          var _editor$current2;
          (_editor$current2 = editor.current) == null || (_editor$current2 = _editor$current2.view) == null || _editor$current2.focus();
          handleInput(sample.val || '');
        },
        children: "Sample"
      })]
    }),
    children: /*#__PURE__*/_jsx(CodeEditor, _extends({
      value: valStr,
      ref: editor,
      readOnly: input !== 'val',
      height: "calc(100vh - 87px)"
    }, other, {
      onFocus: () => dispatch({
        input: 'val'
      }),
      onChange: value => {
        if (input === 'val') {
          handleInput(value);
        }
      }
    }))
  });
}